export default __webpack_public_path__ + "static/media/copy-solid.241f87db.svg";